import { useWebBooking } from "api/api-hooks/use-web-booking";
import ActivityListSkeleton from "components/selection-components/select-activity/activity-list-skeleton";
import SelectActivity from "components/selection-components/select-activity/select-activity";
import { ActivityProvider } from "context/activity-provider";
import { PreorderProvider } from "context/preorder-provider";
import { useBookingStateContext } from "hooks/use-booking-state";
import { error } from "logger/logger";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Routes } from "routes";

const AvailabilityActivityBooking = () => {
    const booking = useWebBooking();
    const { guests } = useBookingStateContext();
    const { system, unitId } = useParams();
    const navigate = useNavigate();

    const { data, isPending, isLoading } = booking;

    useEffect(() => {
        if (!data && !isLoading && !guests && !isPending) {
            // Handle the case when data is not available and guests are not set
            void navigate(`/${system}/${unitId}/${Routes.ACTIVITY_BOOKING}`);
            error("No data available and guests are not set");
        }
    }, [data, guests, isLoading, isPending, navigate, system, unitId]);

    return (
        <ActivityProvider>
            <PreorderProvider>
                {!isPending || guests ? <SelectActivity /> : <ActivityListSkeleton />}
            </PreorderProvider>
        </ActivityProvider>
    );
};

export default AvailabilityActivityBooking;
